import { Timestamp } from 'firebase/firestore';

export const toSwiftDate = (date) => {
  return Timestamp.fromDate(date);
};

export const fromSwiftDate = (swiftDate) => {
  return swiftDate?.toDate();
};
